/**
 * @description Component-FavoriteIcon
 */
import './index.less';

import cls from 'classnames';
import { FC } from 'react';

import StarWhite from '../assets/icon_fav_off.svg?react';
import Star from '../assets/icon_fav_on.svg?react';
interface IPropTypes {
  className?: string;
  favorite: boolean;
  onClick?: () => void;
}
const FavoriteIcon: FC<IPropTypes> = function ({ className, favorite, onClick }) {
  const props: Omit<IPropTypes, 'favorite'> = {
    onClick,
  };
  return (
    <>
      {favorite ? (
        <Star className={cls('syn-favorite-icon', 'syn-favorite-icon_star', className)} {...props} />
      ) : (
        <StarWhite className={cls('syn-favorite-icon', className)} {...props} />
      )}
    </>
  );
};

export default FavoriteIcon;
